import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { AppService } from './_services/app.service';
import { AuthenticationService } from './_services/authentication.service';
import { DocumentsService } from './_services/documents.service';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';

import { DialogUploadComponent } from './_components/dialog-upload/dialog-upload.component';
import { ProductReceiveDialogComponent } from './_components/product-receive-dialog/product-receive-dialog.component';


import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})


export class AppComponent implements OnInit {
  title = 'AZASA';
  sideNavOpened = true;
  logged = false;
  isOpened = false;
  showingMenuAdd = false;
  user: any;


  fSearch = this.fb.group({
    search: [''],
  });

  isHandset = false;


  get isLoginRoute(): boolean {
    return this.router.url.startsWith('/login');
  }

  constructor(
    private iconRegistry: MatIconRegistry,
    public appSvc: AppService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private authSvc: AuthenticationService,
    private dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private docsSvc: DocumentsService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.iconRegistry.addSvgIcon(
      'pin',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/pin.svg')
    );
    this.iconRegistry.addSvgIcon(
      'trash',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/trash.svg')
    );
    this.iconRegistry.addSvgIcon(
      'trash_opened',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/trash_opened.svg'
      )
    );
  }


  ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isHandset = result.matches;
    });
    this.checkIfLogged();
    setTimeout(() => {
      this.appSvc.getComunidades();
    }, 500);
  }

  checkIfLogged() {
    const api_key = localStorage.getItem('api_key');
    if (api_key) {
      this.authSvc.signinCheck().subscribe((res) => {
        console.log(res);
        if (res.result) {
          this.user = res.data;
          console.log('🚀 ~ file: app.component.ts:73 ~ AppComponent ~ this.authSvc.signinCheck ~ this.user:', this.user);
          this.logged = true;
          this.isOpened = false;
        } else {
          this.logged = false;
          this.isOpened = false;
        }
      });
    }
  }

  globalSearch() {
    console.log('🚀 ~ file: app.component.ts ~ line 77 ~ AppComponent ~ globalSearch ~ this.fSearch.value', this.fSearch.value)
    this.appSvc.documentsDocType = 'albaranes';
    this.docsSvc.getByIdent(this.fSearch.value.search, 'albaranes').subscribe((res) => {
      console.log('🚀 ~ file: app.component.ts ~ line 81 ~ AppComponent ~ globalSearch ~ res', res);
      // this.appSvc.documentsFilterPending = true;
      // this.appSvc.documentsFilter = {
      //   color: 'primary',
      //   field: 'id',
      //   dbfield: 'id',
      //   name: 'id',
      //   label: 'Id',
      //   bitwise: '&&',
      //   operation: 'in',
      //   explanation: '',
      //   value: res.data.join(','),
      //   selected: true,
      //   isgroup: false
      // };
      // this.router.navigate(['/documentos']);
      this.router.navigateByUrl('/documentos');
    });
  }

  openFileDialog() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    this.dialog.open(DialogUploadComponent, dialogConfig);
  }

  receiveProduct() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    this.dialog.open(ProductReceiveDialogComponent, dialogConfig);
  }

  toggleSideNav(): void {
    this.sideNavOpened = !this.sideNavOpened;
    localStorage.setItem('sideNavOpened', this.sideNavOpened ? 'true' : '');
  }

  closeSideNav(): void {
    this.sideNavOpened = false;
    localStorage.setItem('sideNavOpened', '');
  }

  logout(): void {
    this.authSvc.logout();
    this.checkIfLogged();
    this.router.navigate(['/login']);
  }
}
